
import { Options, Vue } from 'vue-class-component';
import CountryPicker from "@/components/CountryPicker.vue"
import NumberPicker from "@/components/NumberPicker.vue"
import DatePicker from "@vuepic/vue-datepicker"
import {Prop} from "vue-property-decorator";


@Options({
  components: {
    CountryPicker,
    DatePicker,
    NumberPicker,
  },
})
export default class extends Vue {
  @Prop({required: true})
  value!: {[key:string]: string};
  @Prop({required: true})
  modelValue!: string[];
  @Prop({default: null})
  variants!: {[key:string]: number} | null

  toggleValue(key:string){
    const index = this.modelValue.indexOf(key);
    if(index >= 0){
      this.modelValue.splice(index, 1);
      this.$emit("update:modelValue",this.modelValue);
    }else{
      this.modelValue.push(key)
    }
    this.$emit("input");
  }

  declOfNum(number: number, words: string[]){
    return words[(number % 100 > 4 && number % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ? Math.abs(number) % 10 : 5]];
  }

}
